(function () {
  var root = document.querySelector(".alt");
  if (!root) return;

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var videos = root.querySelectorAll("video");

  if (reduce) {
    videos.forEach(function (video) {
      video.removeAttribute("autoplay");
      try { video.pause(); } catch (err) {}
    });
  } else {
    document.documentElement.classList.add("alt-motion");

    var reveal = root.querySelectorAll(".alt-reveal, .alt-wipe");
    if ("IntersectionObserver" in window) {
      var seen = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-in");
          seen.unobserve(entry.target);
        });
      }, { threshold: 0.18, rootMargin: "0px 0px -8% 0px" });
      reveal.forEach(function (el) { seen.observe(el); });
    } else {
      reveal.forEach(function (el) { el.classList.add("is-in"); });
    }

    var parallax = root.querySelectorAll("[data-parallax]");
    var ticking = false;
    function paint() {
      var view = window.innerHeight || 1;
      parallax.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var progress = (rect.top + rect.height / 2 - view / 2) / view;
        var shift = Math.max(-28, Math.min(28, progress * -24));
        var scale = el.closest(".alt-still") ? " scale(1.12)" : "";
        el.style.transform = "translate3d(0," + shift.toFixed(2) + "px,0)" + scale;
      });
      ticking = false;
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(paint);
    }
    paint();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    if ("IntersectionObserver" in window) {
      var playing = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            var play = video.play();
            if (play && play.catch) play.catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.2 });
      videos.forEach(function (video) { playing.observe(video); });
    }
  }

  var form = document.getElementById("altSignupForm");
  var emailInput = document.getElementById("altEmailInput");
  var submitButton = document.getElementById("altSubmitButton");
  var errorMessage = document.getElementById("altErrorMessage");
  var errorText = document.getElementById("altErrorText");
  var successState = document.getElementById("altSuccess");
  if (!form || !emailInput || !submitButton || !errorMessage || !errorText || !successState) return;

  var isShopify = form.hasAttribute("data-shopify");
  var isSubmitting = false;
  var subscribedEmails = new Set();

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function revealMessage(el) {
    if (!el || !el.getBoundingClientRect) return;
    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (rect.top < 0 || rect.bottom > vh) {
      el.scrollIntoView({ block: "nearest", inline: "nearest" });
    }
  }

  function showError(message) {
    errorText.textContent = message;
    errorMessage.hidden = false;
    emailInput.setAttribute("aria-invalid", "true");
    emailInput.setAttribute("aria-describedby", "altErrorMessage");
    revealMessage(errorMessage);
  }

  function clearError() {
    if (!errorMessage.hidden) {
      errorMessage.hidden = true;
      emailInput.removeAttribute("aria-invalid");
      emailInput.removeAttribute("aria-describedby");
    }
  }

  function setLoading(loading) {
    isSubmitting = loading;
    emailInput.readOnly = loading;
    submitButton.disabled = loading;
    submitButton.setAttribute("aria-busy", loading ? "true" : "false");
  }

  function trackSignup(email) {
    try {
      if (typeof gtag === "function") gtag("event", "sign_up", { method: "Early Access Waitlist" });
      if (typeof fbq === "function") fbq("track", "Lead", { content_name: "Early Access Waitlist" });
    } catch (err) {}
    if (!email) return;
    try {
      window.dispatchEvent(new CustomEvent("sunok:subscribed", { detail: { email: email } }));
    } catch (err) {}
  }

  function showSuccess(email) {
    subscribedEmails.add(email);
    trackSignup(email);
    form.hidden = true;
    successState.hidden = false;
    revealMessage(successState);
  }

  emailInput.addEventListener("input", clearError);
  form.addEventListener("submit", function (e) {
    if (!isShopify || isSubmitting) e.preventDefault();
    if (isSubmitting) return;
    var email = emailInput.value.trim().toLowerCase();
    if (!email || !isValidEmail(email)) {
      e.preventDefault();
      showError("Please enter a valid email address.");
      emailInput.focus();
      return;
    }
    if (subscribedEmails.has(email)) {
      e.preventDefault();
      showError("You're already on the list.");
      emailInput.focus();
      return;
    }
    emailInput.value = email;
    clearError();
    setLoading(true);
    if (isShopify) {
      try { sessionStorage.setItem("sunok:pendingEmail", email); } catch (err) {}
    } else {
      e.preventDefault();
      setTimeout(function () {
        setLoading(false);
        showSuccess(email);
      }, 280);
    }
  });

  var initialState = form.querySelector("[data-signup-state]");
  if (initialState && initialState.getAttribute("data-posted") === "true" && /customer_posted=true/.test(window.location.search)) {
    var pendingEmail = null;
    try {
      pendingEmail = sessionStorage.getItem("sunok:pendingEmail");
      sessionStorage.removeItem("sunok:pendingEmail");
    } catch (err) {}
    trackSignup(pendingEmail);
  }

  window.addEventListener("pageshow", function (e) {
    if (e.persisted) setLoading(false);
  });
})();
